import { useState } from 'react';

// Third-party
import clsx from 'clsx';
import { useAtom, useSetAtom } from 'jotai';

// Atoms
import {
    messageFilterSecondaryAtom,
    openedMessageAtom
} from '@/components/pages/conversations/SocialInbox/atoms';

// Constants/Libs/Types
import type { MessageFilter } from '@/components/pages/conversations/SocialInbox/types';
import useTranslation from 'next-translate/useTranslation';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';

export const ConversationFilters = () => {
    const [opened, setOpened] = useState(false);
    const [messageFilterSecondary, setMessageFilterSecondary] = useAtom(messageFilterSecondaryAtom);
    const setOpenedMessage = useSetAtom(openedMessageAtom);

    const { t } = useTranslation('conversations');

    const onSelectFilter = (filter: MessageFilter['filter']) => {
        setOpenedMessage(null);
        setMessageFilterSecondary((prev) => ({ ...prev, filter }));
    };

    return (
        <div className="flex flex-col gap-2 sm:gap-4">
            <button
                onClick={() => setOpened((prev) => !prev)}
                className="flex items-center space-x-3 text-icoBlack dark:text-white">
                <Icon icon="filter" className="text-16" />
                <span className="text-sm">{t('social_inbox.filters.title')}</span>
                <Icon
                    icon="chevron-bottom"
                    className={clsx(
                        'text-16 text-icoGray-400 duration-300',
                        opened ? 'rotate-180' : 'rotate-0'
                    )}
                />
            </button>
            {opened ? (
                <div className="flex w-full gap-2">
                    <Button
                        size="xs"
                        variant={messageFilterSecondary.filter === 'all' ? 'primary' : 'secondary'}
                        onClick={() => onSelectFilter('all')}>
                        {t('social_inbox.filters.all')}
                    </Button>
                    <Button
                        size="xs"
                        variant={
                            messageFilterSecondary.filter === 'unread' ? 'primary' : 'secondary'
                        }
                        onClick={() => onSelectFilter('unread')}>
                        {t('social_inbox.filters.unread')}
                    </Button>
                </div>
            ) : null}
        </div>
    );
};
